/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createForEach } from '../../factoriesAny.js';
export var forEachDependencies = {
  typedDependencies: typedDependencies,
  createForEach: createForEach
};